export class OAuthStateMismatchError extends Error {
  constructor() {
    super();
    this.name = 'OAuthStateMismatchError';
    this.message = `State doesn't match.`;
  }
}
